import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { useRouter } from 'next/router';
import { format } from 'date-fns/format';
import { addMinutes } from 'date-fns/addMinutes';
import { sv, nb, fi, enGB } from 'date-fns/locale';
import ClockIcon from '@assets/ClockIcon';
import CalendarIcon from '@assets/CalendarIcon';
import { EventDateTime } from '@pages/[lang]/live/[slug]';
import { LiveEventQuery } from '@gql/generated';

const Title = styled.p`
  font-size: 13px;
  font-weight: 500;
  margin: 0;
`;

const EventName = styled.h1`
  font-size: 20px;
  color: #243240;
  font-weight: bold;
  line-height: 1.333;
  text-transform: capitalize;
`;

const InstructorName = styled.p`
  font-size: 14px;
  line-height: 22px;
  margin: 5px 0 10px;
`;

const EventSection = styled.div``;

const localeMap = {
  en: enGB,
  se: sv,
  no: nb,
  fi,
};

type Props = {
  event: Pick<
    LiveEventQuery['liveEvent'],
    'title' | 'primaryInstructor' | 'eventDates' | 'duration'
  >;
};
export const LiveEventFormInfo = (props: Props) => {
  const { event } = props;

  const router = useRouter();
  const lang = router?.query?.lang as string;

  const instructor = event?.primaryInstructor;

  return (
    <>
      <Title>
        <Trans id="live.payment_page.summary_title" />
      </Title>
      <EventName data-testid="liveEvent--EventName">{event.title}</EventName>
      {instructor?.name ? (
        <InstructorName>
          <Trans id="metadata.with" /> {instructor.name}
        </InstructorName>
      ) : null}
      <EventSection>
        {event.eventDates.map((date, i) => {
          const eventDate = new Date(date);
          const fullDate = format(eventDate, 'EEEE dd MMMM yyyy', {
            locale: localeMap[lang],
          });

          const startTime = format(eventDate, 'H:mm');
          const endTime = format(
            addMinutes(eventDate, event.duration),
            'H:mm OOO'
          );

          return (
            <EventDateTime key={i}>
              <span>
                <CalendarIcon /> {fullDate}
              </span>
              <span>
                <ClockIcon /> {startTime} - {endTime}
              </span>
            </EventDateTime>
          );
        })}
      </EventSection>
    </>
  );
};
